import { FLOW_GROUPS, type FlowByGroup } from '../../flow/groups';
import type { ChartSeries } from '../seriesTypes';

export function flowSeries(byGroup: FlowByGroup): ChartSeries[] {
    return FLOW_GROUPS.map(group => {
        const points = (byGroup.get(group.id) ?? []).map(p => ({
            t: p.t,
            v: p.netCapital,
        }));
        const raw = byGroup.get(group.id) ?? [];
        return {
            id: `flow:${group.id}`,
            label: group.label,
            color: group.color,
            unit: 'usd',
            draw: 'step',
            axis: 'own',
            home: 'flow',
            movable: true,
            hasData: raw.some(
                p => p.wallets > 0 || p.capitalYes > 0 || p.capitalNo > 0
            ),
            data: { kind: 'points', points },
        };
    });
}
